import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesCambioDeDomicilio() {
  return (
    <ClipperPlaceholder title="Cambio de Domicilio" category="Novedades" />
  );
}
